// El editor de plano y la barra superior (botón Acciones) viven en lugares distintos del árbol: este flag compartido
// permite que la barra pida confirmación antes de salir del editor con cambios sin guardar.
let dirty = false;

export const setTablesEditorDirty = (value) => {
  dirty = Boolean(value);
};

export const confirmLeaveTablesEditor = () => !dirty || window.confirm('Hay cambios sin guardar en el plano. ¿Descartarlos?');
